import { useAuth } from 'react-oidc-context';

const useAllRoles = () => {
  const auth = useAuth();
  const roles = auth.user?.profile?.role || [];
  return Array.isArray(roles) ? roles : [roles];
};

export { useAllRoles };